var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"ml-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.AtualizarDespesa()}}},[_c('span',[_vm._v(" Atualizar despesa ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }